import { sample } from "lodash"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type RandomPathNodeOptions = {} & SimpleManaNodeOptions

export default class RandomPathNode extends SimpleManaNode {

	static nodeType = 'RandomPathNode'
	static nodeName = "Random path node"
	static nodeDesc = "Transfers particles to one of the viable connections, picked at random"
	static nodeIcon = '❔'
	static category = NodeCategories.Logistics

	getSymbol() {
		return RandomPathNode.nodeIcon
	}

	getViableRoutes(particle: ManaParticle) {
		const viablePaths = super.getViableRoutes(particle)
		const random = sample(viablePaths)

		return random ? [random] : []
	}

}